import React, { FC } from 'react';
import { DatePickerInput, DatesRangeValue, DateValue } from '@mantine/dates';
import { ReactComponent as IconCalendar } from '../img/iconCalendar.svg';
import { ReactComponent as IconCloseGray } from '../img/iconCloseGray.svg';
import styles from './EmployedsFilterDateInput.module.scss';

export interface FilterDateInputProps {
  value: Date | null | DatesRangeValue;
  onChange: (value: DateValue | DatesRangeValue | Date[] | null) => void;
  placeholder?: string;
  type?: 'single' | 'range';
  className?: string;
}

export const EmployedsFilterDateInput: FC<FilterDateInputProps> = ({
  value,
  onChange,
  placeholder = 'Выбери дату',
  type = 'single',
  className,
}) => {
  return (
    <DatePickerInput
      type={type === 'range' ? 'range' : undefined}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      size='sm'
      className={`${styles.dateInput} ${className || ''}`}
      valueFormat='DD.MM.YYYY'
      highlightToday
      rightSection={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {value && Array.isArray(value) && value[0] && value[1] ? (
            <IconCloseGray
              style={{ cursor: 'pointer', marginRight: 4, width: 16, height: 16 }}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                onChange(null);
              }}
            />
          ) : (
            <IconCalendar style={{ pointerEvents: 'none' }} />
          )}
        </div>
      }
      rightSectionPointerEvents='all'
      allowSingleDateInRange
      popoverProps={{
        withinPortal: true,
        zIndex: 10000,
        position: 'bottom-end',
        offset: 4,
        classNames: {
          dropdown: styles.calendarDropdown,
        },
      }}
    />
  );
};
